import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import swal from "sweetalert";
import {
  get_BlogCategoryDrp,
  get_BlogData,
  get_BlogSingleData,
} from "../../../store/actions/CommanAction";
import user from "./../../../images/task/user.jpg";
import DatePicker from "react-datepicker";
import {
  getShowingDateText,
  getShowingMonthDateYear,
 
} from "../Utility/Utility";

import { CKEditor } from "@ckeditor/ckeditor5-react";
import profile_icon from "../../../icons/flaticon/profile_icon.png";
import "ckeditor5/ckeditor5.css";
import { ClassicEditor } from "ckeditor5";
import { Link } from "react-router-dom";
import ReactQuill from "react-quill-new";

const BlogAdd = ({ onClose, modalOpen }) => {
  const dispatch = useDispatch();
  const userdata = sessionStorage.getItem("UserData");

  const parsedUserData = userdata ? JSON.parse(userdata) : null;

  const adminusername = parsedUserData?.userName;

  const BlogSingleData = useSelector(
    (state) => state.feedBackReducer.BlogSingleData
  );
  const BlogCategoryDrpData = useSelector(
    (state) => state.feedBackReducer.BlogCategoryDrpData
  );
  const BlogID = useSelector((state) => state.feedBackReducer.BlogID);
  const [EditValue, setEditValue] = useState();
  const [file, setFile] = React.useState(null);
  const [IsActive, setIsActive] = useState(true);
  const [CreatedTime, setCreatedTime] = useState();
  const [loading, setloading] = useState(false);

  // ReactQuill
  const [shortDesContent, setShortDesContent] = useState("");
  const [blogContent, setBlogContent] = useState("");
  const [authorname, setAuthorName] = useState([]);

  const [Value, SetValue] = useState({
    BlogID: 0,
    CreatedByUser: "1",
    IsActive: "1",
    Title: "",
    Status: "",
    AuthorName: "",
    AuthorId: "",
    BlogCategoryID: "",
    IsTrending: "",
    CountReViews: "",
    CreatedTime: "",
    MetaTitle: "",
    MetaKeywords: "",
    MetaDescription: "",
    SchedulePublish: "",

    ShortDescription: "",
    Blog: "",

    BlogDoc: "",
    ShortDescriptionDoc: "",
    IsHomePage: false,
  });

const [metaError, setMetaError] = useState("");
const [checkingMeta, setCheckingMeta] = useState(false);

  const fileHandler = (e) => {
    const file = e.target.files[0];
    const allowedExtensions =
      /(\.apng|\.png|\.jpg|\.jpeg|\.jfif|\.pjpeg|\.pjp)$/i;
    if (file) {
      if (allowedExtensions.exec(file.name)) {
        setFile(file);
      } else {
        swal("Please upload a valid image file");
      }
    }
  };

  const ChangeDropDown = (e, name) => {
    SetValue((prevData) => ({ ...prevData, [name]: e ? e.value : "" }));
  };

  useEffect(() => {
    dispatch(get_BlogCategoryDrp());
  }, []);

  useEffect(() => {
    BlogID && dispatch(get_BlogSingleData(BlogID));
  }, [BlogID]);

  useEffect(() => {
    if (modalOpen && BlogID == null) {
      SetValue({
        BlogID: 0,
        CreatedByUser: "1",
        IsActive: "1",
        Title: "",
        Status: "",
        AuthorName: "",
        AuthorId: "",
        BlogCategoryID: "",
        IsTrending: "",
        CountReViews: "",
        CreatedTime: "",
        MetaTitle: "",
        MetaKeywords: "",
        MetaDescription: "",
        SchedulePublish: "",
        ShortDescription: "",
        Blog: "",
        BlogDoc: "",
        ShortDescriptionDoc: "",
        IsHomePage: false,
      });
      setFile(null);
      setEditValue(null);
      setShortDesContent("");
      setBlogContent("");
      setCreatedTime("");
    }
  }, [modalOpen, BlogID]);

  useEffect(() => {
    if (EditValue && EditValue.length > 0 && BlogID != null) {
      SetValue({
        ...Value,
        BlogID: BlogID,
        Title: EditValue[0]?.Title,
        ViewCount: EditValue[0]?.ViewCount,
        BlogDoc: EditValue[0]?.BlogDoc,
        ShortDescriptionDoc: EditValue[0]?.ShortDescriptionDoc,
        AuthorName: EditValue[0]?.AuthorName,
        IsTrending: EditValue[0]?.IsTrending,
        CreatedTime: EditValue[0].CreatedTime
          ? getShowingDateText(EditValue[0].CreatedTime)
          : "",
        CountReViews: EditValue[0]?.CountReViews,
        BlogCategoryID: EditValue[0]?.BlogCategoryID,
        Imageurl: EditValue[0]?.Imageurl,
        MetaTitle: EditValue[0]?.MetaTitle,
        MetaKeywords: EditValue[0]?.MetaKeywords,
        MetaDescription: EditValue[0]?.MetaDescription,
        SchedulePublish: EditValue[0]?.SchedulePublish,
        ShortDescription: EditValue[0]?.ShortDescription,
        Blog: EditValue[0]?.Blog,
        CreatedByUser: EditValue[0]?.CreatedByUser,
        IsActive: EditValue[0]?.IsActive,
        Status: EditValue[0]?.Status,
        AuthorId: EditValue[0]?.AuthorId,
        IsHomePage: EditValue[0]?.IsHomePage,
      });
      setShortDesContent(EditValue[0]?.ShortDescription);
      setBlogContent(EditValue[0]?.Blog);
    }
  }, [EditValue, BlogID]);

  const handleAddFormSubmit = async (event) => {
    event.preventDefault();

    let error = false;
    let errorMsg = "";
    if (Value.AuthorName === "") {
      error = true;
      errorMsg = "Please fill AuthorName.";
    }
    if (Value.BlogCategoryID === "") {
      error = true;
      errorMsg = "Please select Category";
    }
    if (Value.Title === "") {
      error = true;
      errorMsg = "Please fill Title";
    }
    if (!Value.ShortDescriptionDoc || Value.ShortDescriptionDoc.trim() === "") {
      error = true;
      errorMsg = "Please fill short Description";
    }

    if (Value.CreatedTime === "") {
      error = true;
      errorMsg = "Please Fill Created time";
    }
    if (Value.MetaKeywords === "") {
      error = true;
      errorMsg = "Please Fill Meta Url";
    }
  if (metaError) {
  error = true;
  errorMsg = "Meta URL already exists";
}
    

    if (!error) {
      const formDataToSave = {
        ...Value,
        // ShortDescription: shortDesContent,
        Blog: blogContent,
        BlogID: 0,
      };
      const formData = new FormData();
      formData.append("image", file);
      formData.append("Data", JSON.stringify(Value));
     

      try {
    const response = await AddUpdate("Blog/Insert_Blog", formData);
 

    if (response?.data?.success) {
      
      onClose();
      dispatch(get_BlogData(IsActive, setloading));
      swal("Good job!", response?.data?.Message || "Successfully Added", "success");
      setFile(null);
      Reset();
    } else {
    
      swal("Oops", response?.data?.Message || "Something went wrong!", "error");
    }
  }
  catch(err){
 swal("Oops", err.message || "Failed to add blog. Please try again ", "error");
  }
  } else {
      swal("Oops", errorMsg, "error");
    }
  };

  const handleAddFormUpdate = async (event) => {
    event.preventDefault();
    let error = false;
    let errorMsg = "";
     if (Value.AuthorName === "") {
      error = true;
      errorMsg = "Please fill AuthorName.";
    }
    if (Value.BlogCategoryID === "") {
      error = true;
      errorMsg = "Please select Category";
    }
    if (Value.Title === "") {
      error = true;
      errorMsg = "Please fill Title";
    }
    if (!Value.ShortDescriptionDoc || Value.ShortDescriptionDoc.trim() === "") {
      error = true;
      errorMsg = "Please fill short Description";
    }

    if (Value.CreatedTime === "") {
      error = true;
      errorMsg = "Please Fill Created time";
    }
    if (Value.MetaKeywords === "") {
      error = true;
      errorMsg = "Please Fill Meta Url";
    }
    if (!error) {
      const formDataToSave = {
        ...Value,
      };
    

try {
  const response = await AddUpdate("Blog/Update_Blog", formDataToSave);
  

  if (response?.data?.success) {
   
    let updateMessage = response?.data?.Message || "Successfully Updated";
    try {
      const parsedData = JSON.parse(response?.data?.data || "{}");
      if (parsedData?.Table?.[0]?.Message) {
        updateMessage = parsedData.Table[0].Message;
      }
    } catch (parseErr) {
      console.warn("Failed to parse update response data:", parseErr);
    }

    dispatch(get_BlogData(IsActive, setloading));
    swal("Good job!", updateMessage, "success");
    setFile(null);
  } else {
    swal("Oops", response?.data?.Message || "Update failed!", "error");
  }
} catch (err) {
  console.error("Update API Error:", err);
  swal("Oops", err.message || "Failed to update blog. Try again later.", "error");
}
  
    } else {
      swal("Oops", errorMsg, "error");
    }
  };

  useEffect(() => {
    setEditValue(BlogSingleData);
  }, [BlogSingleData]);

  const handleUpdatePhoto = async () => {
 
    if (!file) {
      swal("Error", "Please select a photo to upload", "error");
      return;
    }
    const formData = new FormData();
    const dataObject = {
      BlogID: BlogID,
      ModifiedByUser: "1",
    };
    formData.append("Data", JSON.stringify(dataObject));
    formData.append("File", file);
   
    try {
      await AddUpdate("Blog/Update_BlogPhoto", formData);
      swal("Good job!", "Successfully Added", "success");
    } catch (error) {
      swal("Error", "Failed to upload photo", "error");
    } finally {
      // setFile(null);
    }
  };

  const Reset = () => {
    SetValue({
      ...Value,
      Title: "",
      Blog: "",
      ShortDescription: "",
      ViewCount: "",
      BlogDoc: "",
      ShortDescriptionDoc: "",
      RegMobileNo: "",
      AuthorName: "",
      IsTrending: "",
      CreatedTime: "",
      CountReViews: "",
      BlogCategoryID: "",
      // new Added Parameters
      MetaTitle: "",
      MetaKeywords: "",
      MetaDescription: "",
      SchedulePublish: "",
      IsHomePage: false,
    });
  };

  const handleChange = (e) => {
    if (e.target.name === "IsTrending") {
      SetValue({
        ...Value,
        [e.target.name]: e.target.checked,
      });
    } else {
      SetValue({
        ...Value,
        [e.target.name]: e.target.value,
      });
    }
  };

  const handleChangeReactQuill = (value) => {
    setShortDesContent(value);
  };

  const handleChangeReactQuillBlog = (value) => {
  
    setBlogContent(value);
  };

  const customSelectStyles = {
    control: (provided, state) => ({
      ...provided,
      border: "1px solid #fdba74",
      borderRadius: 6,
      fontSize: 14,
      backgroundColor: "#fff",
      boxShadow: state.isFocused
        ? "0 0 0 2px rgba(253, 186, 116, 0.2)"
        : "none",
      borderColor: state.isFocused ? "#fdba74" : "#fdba74",
      minHeight: 39,
      outline: "none",
      ":hover": {
        borderColor: "#fdba74",
      },
    }),
  };

  const getauthornamedata = async () => {
    const res = await AddUpdate("BlogAuthorName/GetData_BlogAuthorName");
    const data = res.data.data;
    const parcedata = JSON.parse(data);
    const datas = parcedata?.Table || [];
  
    setAuthorName(datas);
  };

  useEffect(() => {
    getauthornamedata();
  }, []);


const modules = {
    toolbar: [
     
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ header: 1 }, { header: 2 },{ header: 3 }],
      [{ font: [] }],
      [{ size: [] }],

     
      ["bold", "italic", "underline", "strike"], 
      [{ script: "sub" }, { script: "super" }], 
      [{ color: [] }, { background: [] }], 

      
      [{ align: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],

      
      ["blockquote", "code-block"],

    
      ["link", "image", "video", "formula"],

      
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "script",
    "color",
    "background",
    "align",
    "list",
    "bullet",
    "indent",
    "blockquote",
    "code-block",
    "link",
    "image",
    "video",
    // "formula",
  ];

 const checkMetaExist = async (value) => {
  if (!value) {
    setMetaError("");
    return;
  }

  try {
    const payload = {
      BlogID: Value.BlogID || 0,
      MetaKeywords: value,
    };

    const res = await AddUpdate("Blog/BlogCheckNameExist", payload);

    
    const parsed = JSON.parse(res?.data?.data || "{}");
    const exist = parsed?.Table?.[0]?.BlogExist;

    if (exist == 1) {
      setMetaError("Meta URL already exists");
    } else {
      setMetaError("");
    }

  } catch (err) {
    console.log("error", err);
  }
};


useEffect(() => {
  const timer = setTimeout(() => {
    checkMetaExist(Value.MetaKeywords);
  }, 500);

  return () => clearTimeout(timer);
}, [Value.MetaKeywords]);

  return (
    <>
      <div className="">
        <form className="form-card">
          <div className="row">
            
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label>
                  Title <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  name="Title"
                  autoComplete="off"
                  required
                  value={Value.Title}
                  placeholder="Enter title"
                  onChange={handleChange}
                />
              </div>

            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label>Status</label>
                <Select
                  name="Status"
                  value={[
                    { value: "Draft", label: "Draft" },
                    { value: "Publish", label: "Publish" },
                  ].find((opt) => opt.value === Value.Status)}
                  options={[
                    { value: "Draft", label: "Draft" },
                    { value: "Publish", label: "Publish" },
                  ]}
                  onChange={(e) => ChangeDropDown(e, "Status")}
                  placeholder="Select Status"
                  isClearable
                  styles={customSelectStyles}
                />
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label>
                  Author Name <span className="text-danger">*</span>
                </label>
                <Select
                  name="AuthorName"
                  value={authorname
                    .map((opt) => ({
                      value: opt.AuthorName,
                      label: opt.AuthorName,
                    }))
                    .find((opt) => opt.value === Value.AuthorName)}
                  options={authorname.map((opt) => ({
                    value: opt.AuthorName,
                    label: opt.AuthorName,
                  }))}
                  onChange={(e) => ChangeDropDown(e, "AuthorName")}
                  placeholder="Select Author..."
                  isClearable
                  styles={customSelectStyles}
                />
              </div>
            </div>
            <div className="form-group mb-3 col-md-4 col-12">
              <label>
                Category <span className="text-danger">*</span>
              </label>
              <div className="contact-name">
                <Select
                  name="BlogCategoryID"
                  value={BlogCategoryDrpData?.find(
                    (obj) => obj.value === Value?.BlogCategoryID
                  )}
                  options={BlogCategoryDrpData}
                  onChange={(e) => ChangeDropDown(e, "BlogCategoryID")}
                  placeholder="Select Blog Category"
                  isClearable
                  styles={customSelectStyles}
                />
              </div>
            </div>
            <div className="col-md-2 d-flex align-items-center mt-4 mb-3">
              <div className="form-check">
                <input
                  type="checkbox"
                  name="IsTrending"
                  id="flexCheckDefault"
                  checked={Value.IsTrending}
                  onChange={handleChange}
                />
                <label className="ms-2" htmlFor="flexCheckDefault">
                  Is Trending
                </label>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="form-group mb-3 col-12 ">
              <label>
                Short Description <span className="text-danger">*</span>
              </label>
              <div className="custom-ekeditor">
                <ReactQuill
                  value={Value.ShortDescription}
                 

                  onChange={(value, delta, source, editor) => {
                    const text = editor?.getText();
                   
                    SetValue((prevValue) => ({
                      ...prevValue,
                      ShortDescription: value,
                      ShortDescriptionDoc: text,
                    }));
                  }}
                  modules={modules}
                  formats={formats}
                  theme="snow"
                  placeholder="Write something..."
                />
              </div>
            </div>
            <div className="form-group mb-3 col-12 ">
              <label>Blog</label>
              <div className="custom-ekeditor">
                <ReactQuill
                  value={Value.Blog}
                  

                  onChange={(value, delta, source, editor) => {
                    const text = editor?.getText();
                  
                    SetValue((prevValue) => ({
                      ...prevValue,
                      Blog: value,
                      BlogDoc: text,
                    }));
                  }}
                  modules={modules}
                  formats={formats}
                  theme="snow"
                  placeholder="Write something..."
                />


              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 mb-3">
              <div className="form-group ">
                <label>Count/Reviews</label>
                <div className="contact-name">
                  <input
                    type="number"
                    autoComplete="off"
                    name="CountReViews"
                    required="required"
                    onChange={handleChange}
                    placeholder="Select Count.."
                    value={Value.CountReViews}
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-3 ">
              <div className="form-group">
                <label>
                  Created/Time <span className="text-danger">*</span>
                </label>

                <div style={{ width: "100%" }}>
                  <input
  type="date"
  // className="form-control"
  id="CreatedTime"
  name="CreatedTime"
  style={{ width: "100%" }}
  // max={new Date().toISOString().split("T")[0]} 
  value={
    Value?.CreatedTime
      ? new Date(Value.CreatedTime).toISOString().split("T")[0]
      : ""
  }
  onChange={(e) => {
    const selectedDate = e.target.value ? new Date(e.target.value) : null;

    setCreatedTime(selectedDate); 

    SetValue({
      ...Value,
      CreatedTime: selectedDate
        ? getShowingMonthDateYear(selectedDate)
    :""})
  }}
  placeholder="Select..."
/>

                </div>
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label>Meta Title</label>
                <input
                  type="text"
                  name="MetaTitle"
                  placeholder="Enter meta title"
                  value={Value.MetaTitle}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label>Meta Url<span className="text-danger">*</span></label>
              <input
  type="text"
  name="MetaKeywords"
  placeholder="Enter Meta url"
  value={Value.MetaKeywords}
  onChange={handleChange}
/>

{metaError && (
  <small className="text-danger">{metaError}</small>
)}
              </div>
            </div>
            <div className="col-md-12 mb-3">
              <div className="form-group">
                <label>Meta Description</label>
                <textarea
                  name="MetaDescription"
                  rows="3"
                  placeholder="Enter meta description"
                  value={Value.MetaDescription}
                  onChange={handleChange}
                ></textarea>
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group flex-grow-1">
                <label>Schedule Publish</label>
                <div style={{ width: "100%" }}>
                  <input
                    type="date"
                    style={{ width: "100%" }}
                    id="SchedulePublish"
                    name="SchedulePublish"
                    value={
                      Value?.SchedulePublish
                        ? new Date(Value.SchedulePublish)
                            .toISOString()
                            .split("T")[0]
                        : ""
                    }
                    onChange={(e) => {
                      const selectedDate = e.target.value;
                      SetValue({
                        ...Value,
                        SchedulePublish: selectedDate
                          ? getShowingMonthDateYear(new Date(selectedDate))
                          : null,
                      });
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label>Admin User</label>
                <input
                  type="text"
                  name="AdminUser"
                  placeholder="Enter admin username"
                  // value={Value.AdminUser}
                  Value={adminusername}
                  readOnly
                  autoComplete="off"
                  required
                />
              </div>
            </div>
            <div className="col-md-6 mb-3">
              <div className="form-group">
                <label>Blog Image</label>
                <input type="file" onChange={fileHandler} />
                {file && (
                  <img
                    src={URL.createObjectURL(file)}
                    alt="Preview"
                    style={{ width: 100, marginTop: 10 }}
                  />
                )}
                {Value.Imageurl && !file && (
                  <img
                    src={`https://${Value.Imageurl.replace(/\\/g, "/")}`}
                    alt="Preview"
                    style={{ width: 100, marginTop: 10 }}
                  />
                )}
                {BlogID && (
                  <button
                    type="button"
                    onClick={handleUpdatePhoto}
                    disabled={!file || !BlogID}
                    className="btn btn-primary text-white p-1 mx-3"
                  >
                    Upload Photo
                  </button>
                )}
              </div>
            </div>

            <div className="form-group mb-3 col-4">
              <label className="text-black font-w500">Is Home Page</label>
              <div className="d-flex align-items-center gap-2">
                <input
                  type="checkbox"
                  name="IsHomePage"
                  checked={Value?.IsHomePage || false}
                  onChange={(e) =>
                    SetValue((prev) => ({
                      ...prev,
                      IsHomePage: e.target.checked,
                    }))
                  }
                  className="form-check-input p-0"
                  style={{
                    width: "16px",
                    height: "16px",
                    cursor: "pointer",
                  }}
                  id="isHomePageCheckbox"
                />
              </div>
            </div>
          </div>
          <div className="button-group">
            {BlogID ? (
              <button type="submit" onClick={handleAddFormUpdate}>
                Update
              </button>
            ) : (
              <button type="submit" onClick={handleAddFormSubmit}>
                Save Blog
              </button>
            )}
          </div>
        </form>
      </div>
    </>
  );
};
export default BlogAdd;
